// Operation — Pipeline Visites AMO (4 steppers : Planifiées → Effectuées → Payées → Facturées).
import { ArrowRight, Loader2 } from "lucide-react";
import { useOperationFetch } from "./useOperationFetch";

function Step({ label, value, color, isLast }) {
  return (
    <div className="flex items-center gap-2 flex-1 min-w-[120px]">
      <div className="flex flex-col items-center flex-1">
        <div className="rounded-lg px-4 py-3 text-center w-full"
          style={{ background: `${color}15`, border: `1px solid ${color}40` }}>
          <p className="text-2xl font-bold" style={{ color }}>{value}</p>
          <p className="text-xs mt-1" style={{ color: "var(--oh-text-secondary)" }}>{label}</p>
        </div>
      </div>
      {!isLast && <ArrowRight className="w-5 h-5 flex-shrink-0" style={{ color: "var(--oh-text-muted)" }} />}
    </div>
  );
}

export default function OperationPipelineVisitesWidget() {
  const { data, loading } = useOperationFetch();
  if (loading) return <div className="rounded-xl p-5 flex items-center justify-center"
    style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}>
    <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} /></div>;
  const p = data?.pipeline_visites || {};
  return (
    <div className="rounded-xl p-5" style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="operation-pipeline-visites-widget">
      <h3 className="font-semibold mb-4 flex items-center gap-2" style={{ color: "var(--oh-text)" }}>
        <ArrowRight className="w-4 h-4" style={{ color: "var(--oh-stat-orange-text)" }} />
        Pipeline Visites AMO
      </h3>
      <div className="flex items-center gap-2 overflow-x-auto">
        <Step label="Planifiées" value={p.planifiees || 0} color="var(--oh-stat-blue-text)" />
        <Step label="Effectuées" value={p.avec_visite || 0} color="var(--oh-stat-purple-text)" />
        <Step label="Payées" value={p.visites_payees || 0} color="var(--oh-stat-green-text)" />
        <Step label="Factures AMO" value={p.avec_facture || 0} color="var(--oh-stat-cyan-text)" isLast />
      </div>
    </div>
  );
}
